export default "<div [ngClass]=\"exportClass\" class=\"mx-auto citron-background\" (click)=\"exportToExcel()\"></div>\n"